module.exports = __webpack_public_path__ + "img/service-circle.f3d86615.svg";